import { useEffect, useRef, useState } from 'react';
import { openImageInNewTab } from '../../../../utils/images';
import { PDFView } from '../PDFView/PDFView.Component';

export const ViewDocument = ({ show, close, doc }) => {
console.log("{ show, close, doc }",{ show, close, doc })
    const modalRef = useRef()

    useEffect(() => {
        if (show) {
            document.getElementsByTagName("body")?.[0]?.classList.add("modal-open")
            setTimeout(() => {
                document.getElementById("view-document")?.classList.add("show")
            }, 100)
        }
        else {
            document.getElementsByTagName("body")?.[0]?.classList.remove("modal-open")
        }

    }, [show])

    useEffect(() => {
   
        const handler = (event) => {
            if (!modalRef.current) {
                return;
            }
            if (modalRef.current == event.target) {
                close(false);
            }
        };
        document.addEventListener("click", handler, true);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);

    return (
        show ?
            <div>
                <div
                    className="modal fade"
                    id="view-document"
                    aria-modal="true"
                    role="dialog"
                    style={{ display: "block" }}
                    ref={modalRef}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content rounded-15">
                            <div className="modal-body px-70 py-40">
                                <p className="mb-1 font-20 font-weight-800">
                                    {doc.name}
                                </p>
                                <button type='button' className='btn btn-default mt-3' onClick={() => openImageInNewTab(doc.url)}>Download</button>
                                <div className="row form-default">
                                    <div className='scroll-max-height-300'>
                                        <PDFView url={doc?.url}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`modal-backdrop fade ${show && "show"}`} />

            </div> : <div></div>

    )
}